import React from 'react';
import { formatCurrencyGBP } from '../utils/currency';
import './CustomerTable.css';

const CustomerTable = ({ customers, onDelete }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount) => formatCurrencyGBP(amount);

  if (customers.length === 0) {
    return (
      <div className="card">
        <div className="empty-state">
          <p>No customers found. Try adjusting your filters or upload a CSV file.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <h3>Customer Data ({customers.length} customers)</h3>
      <div className="table-container">
        <table className="customer-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Orders</th>
              <th>Total Spent</th>
              <th>Latest Order</th>
              <th>Customer Since</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr>
                <td className="customer-name">{customer.name}</td>
                <td>{customer.email || 'N/A'}</td>
                <td>{customer.phone || 'N/A'}</td>
                <td className="text-center">{customer.total_orders || 0}</td>
                <td className="amount">{formatCurrency(customer.total_spent)}</td>
                <td>{formatDate(customer.last_order_date)}</td>
                <td>{formatDate(customer.created_at)}</td>
                <td>
                  <button
                    onClick={() => onDelete(customer.id)}
                    className="btn-delete"
                    title="Delete customer"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;
